import {
  coreApi_default
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/promoCodes.ts
var verifyPromoCode = async (coupon) => {
  try {
    const response = await coreApi_default.get("/promotions/promocodes/validate", {
      params: {
        coupon
      }
    });
    return { ok: response.data.data, error: response.data.messageCode };
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data
    };
  }
};

export {
  verifyPromoCode
};
